/** Shared primitive types & constants used across `lib/services/*`. */

export type Guid = string;

export type PaginatedResponse<TItem> = {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  itemsCount: number;
  items: TItem[];
};

/** Header value for public tenant-scoped catalog endpoints. */
export const TENANT_HEADER_NAME = 'x-tenant';
